document.documentElement.classList.remove("no-js");

const drawer = document.querySelector("[data-mobile-drawer]");
const openButton = document.querySelector("[data-menu-open]");
const closeButtons = document.querySelectorAll("[data-menu-close]");

function setDrawer(open) {
  if (!drawer) return;
  drawer.dataset.open = String(open);
  drawer.setAttribute("aria-hidden", String(!open));
  document.body.classList.toggle("menu-open", open);
  openButton?.setAttribute("aria-expanded", String(open));
  if (open) {
    setTimeout(() => drawer.querySelector(".mobile-drawer__panel [data-menu-close]")?.focus(), 0);
  } else {
    openButton?.focus();
  }
}

openButton?.addEventListener("click", () => setDrawer(true));
closeButtons.forEach((button) => button.addEventListener("click", () => setDrawer(false)));
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") setDrawer(false);
});

document.querySelectorAll("[data-sort-select]").forEach((select) => {
  select.addEventListener("change", () => select.form?.submit());
});

document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
  const mainImage = gallery.querySelector(".product-gallery__stage > img");
  const count = gallery.querySelector("[data-gallery-count]");
  const thumbnails = gallery.querySelectorAll("[data-gallery-thumbnail]");
  if (!mainImage || !thumbnails.length) return;

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener("click", () => {
      if (thumbnail.getAttribute("aria-current") === "true") return;
      thumbnails.forEach((item) => item.setAttribute("aria-current", "false"));
      thumbnail.setAttribute("aria-current", "true");
      mainImage.src = thumbnail.dataset.galleryImage;
      mainImage.removeAttribute("srcset");
      mainImage.alt = thumbnail.dataset.galleryAlt || "";
      if (count) count.textContent = `${thumbnail.dataset.galleryPosition} / ${thumbnails.length}`;
    });
  });
});

document.querySelectorAll("[data-hero-slider]").forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll("[data-hero-slide]"));
  const dots = Array.from(slider.querySelectorAll("[data-hero-dot]"));
  const previous = slider.querySelector("[data-hero-previous]");
  const next = slider.querySelector("[data-hero-next]");
  const toggle = slider.querySelector("[data-hero-toggle]");
  const toggleLabel = slider.querySelector("[data-hero-toggle-label]");
  const status = slider.querySelector("[data-hero-status]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const interval = Math.max(Number(slider.dataset.interval) || 8000, 6000);
  const autoplayEnabled = slider.dataset.autoplay === "true";
  let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains("is-active")), 0);
  let timer = null;
  let userPaused = false;
  let pointerInside = false;
  let focusInside = false;

  if (slides.length <= 1) return;

  function setSlideFocusable(slide, active) {
    slide.querySelectorAll("a, button, [tabindex]").forEach((element) => {
      if (active) element.removeAttribute("tabindex");
      else element.setAttribute("tabindex", "-1");
    });
  }

  function showSlide(index, announce = false) {
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === activeIndex;
      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", String(!active));
      setSlideFocusable(slide, active);
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === activeIndex;
      dot.classList.toggle("is-active", active);
      dot.setAttribute("aria-current", String(active));
    });
    if (announce && status) {
      status.textContent = `Slaid ${activeIndex + 1} daripada ${slides.length}`;
    }
  }

  function stopAutoplay() {
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  function startAutoplay() {
    stopAutoplay();
    if (
      !autoplayEnabled ||
      userPaused ||
      pointerInside ||
      focusInside ||
      reducedMotion.matches ||
      document.hidden
    ) return;
    timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
  }

  function updateToggle() {
    if (!toggle || !toggleLabel) return;
    toggle.setAttribute("aria-pressed", String(userPaused));
    toggleLabel.textContent = userPaused ? "Main" : "Jeda";
  }

  showSlide(activeIndex);
  updateToggle();
  if (reducedMotion.matches && toggle) toggle.hidden = true;

  previous?.addEventListener("click", () => {
    showSlide(activeIndex - 1, true);
    startAutoplay();
  });
  next?.addEventListener("click", () => {
    showSlide(activeIndex + 1, true);
    startAutoplay();
  });
  dots.forEach((dot, dotIndex) => {
    dot.addEventListener("click", () => {
      showSlide(dotIndex, true);
      startAutoplay();
    });
  });
  toggle?.addEventListener("click", () => {
    userPaused = !userPaused;
    updateToggle();
    if (userPaused) stopAutoplay();
    else startAutoplay();
  });

  slider.addEventListener("pointerenter", () => {
    pointerInside = true;
    stopAutoplay();
  });
  slider.addEventListener("pointerleave", () => {
    pointerInside = false;
    startAutoplay();
  });
  slider.addEventListener("focusin", () => {
    focusInside = true;
    stopAutoplay();
  });
  slider.addEventListener("focusout", () => {
    window.setTimeout(() => {
      focusInside = slider.contains(document.activeElement);
      startAutoplay();
    }, 0);
  });
  slider.addEventListener("keydown", (event) => {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
    event.preventDefault();
    showSlide(activeIndex + (event.key === "ArrowRight" ? 1 : -1), true);
    startAutoplay();
  });
  document.addEventListener("visibilitychange", startAutoplay);
  reducedMotion.addEventListener?.("change", () => {
    if (toggle) toggle.hidden = reducedMotion.matches;
    startAutoplay();
  });

  startAutoplay();
});
